import { Link } from "react-router-dom";
import { LOGO_URL, EVENT } from "@/data/content";
import { ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="bg-[#09090B] border-t border-amber-500/15 py-12 px-5 sm:px-8">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <Logo className="h-16 w-auto" />
        <div className="text-xs text-zinc-500 max-w-[180px] leading-snug">
          {EVENT.presenters}
        </div>
      </div>

      <div className="flex items-center gap-6 text-sm text-zinc-400">
        <a href="#categories" className="hover:text-amber-300">Categories</a>
        <a href="#packages" className="hover:text-amber-300">Packages</a>
        <a href="#contact" className="hover:text-amber-300">Contact</a>
        <Link to="/login" className="flex items-center gap-1.5 hover:text-amber-300" data-testid="footer-admin-link">
          <ShieldCheck className="w-4 h-4" /> Team
        </Link>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-amber-500/10 text-center text-xs text-zinc-600">
      © 2026 South Icon Awards · {EVENT.venue} · All rights reserved.
    </div>
  </footer>
);
